// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if ({ "index":1,"vendors-node_modules_ant-design_icons_es_icons_ArrowLeftOutlined_js-node_modules_ant-design_i-472c22":1 }[chunkId]) return "static/css/" + chunkId + ".css";
  // return url for filenames based on template
  return "static/css/async/" + chunkId + ".css"
}